module.exports = __webpack_public_path__ + "assets/img/banner.4a62e8ed.png";